import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6328_7576)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 30,
					cy: 30,
					r: 30,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.125 28.4813V30C40.125 34.773 40.125 37.1595 38.6422 38.6422C37.1595 40.125 34.773 40.125 30 40.125C25.227 40.125 22.8405 40.125 21.3578 38.6422C19.875 37.1595 19.875 34.773 19.875 30C19.875 25.227 19.875 22.8405 21.3578 21.3578C22.8405 19.875 25.227 19.875 30 19.875H31.5188",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.2161 20.7172L34.5383 21.395L28.3071 27.6262C27.8851 28.0482 27.6741 28.2593 27.4926 28.4919C27.2785 28.7664 27.095 29.0634 26.9452 29.3776C26.8182 29.644 26.7239 29.9271 26.5351 30.4934L25.9308 32.3063L25.5398 33.4793C25.4469 33.7579 25.5195 34.0652 25.7271 34.2729C25.9348 34.4805 26.2421 34.5531 26.5207 34.4602L27.6938 34.0692L29.5066 33.4649L29.5067 33.4649C30.0729 33.2761 30.356 33.1817 30.6224 33.0548C30.9366 32.905 31.2336 32.7215 31.5081 32.5074C31.7407 32.3259 31.9518 32.1149 32.3738 31.6929L38.605 25.4617L39.2828 24.7839C40.4057 23.6609 40.4057 21.8402 39.2828 20.7172C38.1598 19.5943 36.3391 19.5943 35.2161 20.7172Z",
					stroke: "#865E9C",
					strokeWidth: 3
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.6683 21C34.6683 21 34.7586 22.5341 36.1122 23.8878C37.4659 25.2414 39 25.3317 39 25.3317M27.3778 34.5L25.5 32.6222",
					stroke: "#865E9C",
					strokeWidth: 3
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6328_7576",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
